import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import Swiper from "react-id-swiper";
import { getProductCartQty } from "../../helpers/product";
import { Modal } from "react-bootstrap";
import Rating from "./sub-components/ProductRating";
import { connect } from "react-redux";
import { Link } from "react-scroll";
import { addToCompare } from "../../redux/actions/compareActions";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../redux/actions/wishlistActions";
import ProductMobile from "../../pages/shop-product/ProductMobile";

function ProductModal(props) {
  const {
    product,
    currency,
    discountedprice,
    finaldiscountedprice,
    isLoggedUser,
    visualizzaPrezzi,
    cartItems,
    userData,
  } = props;
  const visualizzaGriglia = isLoggedUser || global.visualizzaGrigliaLogOut;
  const visualizzaQuantita = isLoggedUser || global.visualizzaQuantitaLogOut;

  const prodottiSenzaLogin = global.prodottiSenzaLogin;

  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);

  if (!product || product.variation === undefined) {
    //console.log(product)
  }
  const [selectedProductColor, setSelectedProductColor] = useState(
    (product && product.variation ? product.variation[0]?.color : "") || ""
  );

  const [selectedProductSize, setSelectedProductSize] = useState(
    (product && product.variation && product.variation[0]?.size
      ? product.variation[0].size[0].name
      : "") || ""
  );
  const [selectedProductPrice, setSelectedProductPrice] = useState(
    product && product.variation?.lenght > 0 && product.variation[0]?.size
      ? product.variation[0].size[0].pricesco.toFixed(2)
      : product.price?.toFixed(2)
  );
  const [selectedIDArt, setSelectedIDArt] = useState(
    product && product.variation && product.variation[0]?.size
      ? product.variation[0].size[0].IDArtSizeColor
      : 0
  );
  const [productStock, setProductStock] = useState(
    product && product.variation && product.variation[0]?.size
      ? product.variation[0].size[0].stock
      : product?.stock || global.aziendaID == 2
      ? 9999
      : 0
  );
  const [quantityCount, setQuantityCount] = useState(0);

  //const wishlistItem = props.wishlistitem;
  const compareItem = props.compareitem;

  const addToCart = props.addtocart;
  const addToWishlist = props.addtowishlist;
  const removeFromWishlist = props.removeFromWishlist;
  const addToCompare = props.addtocompare;

  const addToast = props.addtoast;
  const cartItem = props.cartitem;
  const wishlistItems = props.wishlistItems;
  const isBetaRicambi = global.aziendaID === 4 ? true : false;
  const clienteVisualizzaPrezzi =
    isLoggedUser && userData?.user?.user?.showPrice
      ? userData?.user?.user?.showPrice === 1
      : false;
  const wishlistItem = product
    ? wishlistItems?.find((_i) => _i.id === product.id)
    : [];
  console.log("isBetaRicambi", isBetaRicambi, clienteVisualizzaPrezzi);

  function fproductCartQty(
    selectedProductColor,
    selectedProductSize,
    withGrid
  ) {
    let cartValue = getProductCartQty(
      cartItems,
      product,
      selectedProductColor,
      selectedProductSize
    );

    //if (withGrid) cartValue +=  getQta(selectedProductSize, selectedProductColor, true);
    return cartValue;
  }

  const productCartQty = getProductCartQty(
    cartItems,
    product,
    selectedProductColor,
    selectedProductSize,
    selectedIDArt
  );

  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);

  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    spaceBetween: 10,
    loopedSlides: 4,
    loop: false,
  };

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    loopedSlides: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: false,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    ),
  };
  var strings = require("../../translations/italian.json");
  function toColor(i) {
    var hex =
      (i & 0xff).toString(16) +
      ((i >> 8) & 0xff).toString(16) +
      ((i >> 16) & 0xff).toString(16) +
      ((i >> 24) & 0xff).toString(16);

    hex += "000000"; // pad result
    hex = hex.substring(0, 6);
    return "#" + hex;
  }

  if (!product || !product.id) return null;

  function getDisponibili(
    Qta,
    inArrivo,
    selectedProductColor,
    selectedProductSize,
    catalogo,
    impCli,
    promo
  ) {
    var sDis = " ";

    if (Qta <= 0 || Qta - inArrivo <= 0)
      sDis = <div style={{ fontWeight: "500" }}>Non Disponibile</div>;
    else if (!promo)
      sDis = (
        <div style={{ fontWeight: "500" }}>
          {"Disponibili: " + (Qta - inArrivo > 500 ? "500+" : Qta - inArrivo)}
          <br />
        </div>
      );
    else
      sDis = (
        <div style={{ fontWeight: "500" }}>
          {"Ultimi  " +
            (Qta - inArrivo > 500 ? "500+" : Qta - inArrivo) +
            " pezzi"}
          <br />
        </div>
      );
    //sDis = "Disponibili: " + (Qta - productCartQty(selectedProductColor, selectedProductSize));
    if (catalogo && Qta <= 0) {
      //sDis = <>{sDis}<br/>{"Su prenotazione"}</>
      sDis = (
        <div style={{ fontSize: "12px", fontWeight: "100" }}>
          <br />
          {"Su prenotazione"}
        </div>
      );
    }

    return sDis;
  }

  function getQtaInArrivo(
    qtaOrdFor,
    qtaImpCli,
    qta,
    catalogo,
    promo,
    onlyString
  ) {
    var sDis = " ";
    var Qta = qta - qtaOrdFor > 0 ? qtaOrdFor : qta;
    if (promo)
      return onlyString ? (
        ""
      ) : (
        <p>
          <br />
          <br />
          <br />
        </p>
      );

    if (Qta <= 0 || qtaImpCli < 0)
      //sDis = "Non in Arrivo";
      sDis = onlyString ? (
        "su Prenotazione"
      ) : (
        <>
          <div style={{ fontSize: "12px", fontWeight: "500" }}>
            <br />
            <br />
          </div>
          <div style={{ fontSize: "12px", fontWeight: "100" }}>
            <br />
            Maggiori quantità
            <br />
            su prenotazione
          </div>
        </>
      );
    else
      sDis = onlyString ? (
        (Qta || "0") + " 5/7 gg"
      ) : (
        <>
          <div style={{ fontSize: "12px", fontWeight: "500" }}>
            In Arrivo: {Qta ? Qta : "0"}
            <br />
            in 5/7 gg
          </div>
          <div style={{ fontSize: "12px", fontWeight: "100" }}>
            <br />
            Maggiori quantità
            <br />
            su prenotazione
          </div>
        </>
      );

    return sDis;
  }

  const getTableInfo = () => {
    //console.log({ isLoggedUser, visualizzaPrezzi, visualizzaGriglia, visualizzaQuantita })
    if (!visualizzaQuantita && !isLoggedUser) return null;

    const colorProduct = product?.variation?.find(
      (_colorProduct) => _colorProduct.color === selectedProductColor
    );
    if (!colorProduct || !colorProduct.size) return null;

    const taglieInfo = colorProduct.size;
    if (!taglieInfo || (taglieInfo || []) === 0) return null;

    const _colorcode = colorProduct.color.split("-")[0];
    const _colorname = colorProduct.color.split("-")[1];
    return (
      <>
        <div>
          <label>
            <span
              title={selectedProductColor.split("-")[1]}
              style={{
                backgroundColor: colorProduct.hexColor
                  ? toColor(colorProduct.hexColor)
                  : "",
                backgroundImage: colorProduct.hexColor
                  ? null
                  : "url('https://dgaplanetshirt.com/assets/img/COLORI/" +
                    _colorcode +
                    ".png')",
                backgroundSize: "contain",
                position: "absolute",
                width: "20px",
                height: "20px",
                border:
                  colorProduct.color === selectedProductColor
                    ? "2px solid #333"
                    : "2px solid #d9d9d9",
                borderRadius: "50%",
                content: "",
                transition: "0.3s",
              }}
            ></span>
            <span style={{ paddingLeft: "50px" }}>{_colorname}</span>
          </label>
        </div>
        <table id="infoTable" style={{ width: "100%" }}>
          <thead style={{ width: "100%" }}>
            <tr>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "30%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Taglia</span>
              </th>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "35%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Disponibile</span>
              </th>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "35%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Arrivi</span>
              </th>
              {isLoggedUser && (
                <th
                  style={{
                    width: "25%",
                    backgroundColor: "#c3c3c3",
                    fontWeight: 700,
                    textAlign: "center",
                    padding: "5px",
                    BorderBottom: "0px",
                    BorderRight: "0px",
                    fontSize: "12px",
                    columnSpan: 2,
                    color: "black",
                    border: "1px solid black",
                  }}
                >
                  <span>Carrello</span>
                </th>
              )}
            </tr>
          </thead>
          <tbody style={{ width: "100%" }}>
            {taglieInfo.map((tagliaInfo) => {
              return (
                <tr>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "30%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>{tagliaInfo.name || 0}</span>
                  </td>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "35%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>
                      {getDisponibili(
                        tagliaInfo.stock,
                        tagliaInfo.qtaOrdFor,
                        tagliaInfo.color,
                        tagliaInfo.name,
                        tagliaInfo.catalogo,
                        tagliaInfo.qtaImpCli,
                        tagliaInfo.promo
                      )}
                    </span>
                  </td>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "35%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>
                      {getQtaInArrivo(
                        tagliaInfo.qtaOrdFor,
                        tagliaInfo.qtaImpCli,
                        tagliaInfo.stock,
                        tagliaInfo.catalogo,
                        tagliaInfo.promo,
                        true
                      ) || ""}
                    </span>
                  </td>
                  {isLoggedUser && (
                    <td
                      style={{
                        width: "25%",
                        textAlign: "center",
                        padding: "5px",
                        BorderBottom: "0px",
                        BorderRight: "0px",
                        fontSize: "12px",
                        columnSpan: 1,
                        color: "black",
                        border: "1px solid black",
                        fontWeight: 700,
                      }}
                    >
                      <span>
                        {fproductCartQty(
                          selectedProductColor,
                          tagliaInfo.name,
                          true
                        )}
                      </span>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };
  var qtaInCart = getProductCartQty(cartItems, product, null, null);
  return (
    <Fragment>
      <Modal
        show={props.show}
        onHide={props.onHide}
        className="product-quickview-modal-wrapper"
        style={{ paddingTop: "10px", paddingBottom: "10px", margin: "0% auto" }}
        {...props}
      >
        {/*<Modal.Header style = {{height: '35px'}} closeButton></Modal.Header>*/}

        {(global.aziendaID == 2 || global.aziendaID == 4) && (
          <div className="modal-body">
            <div className="row">
              <div className="col-md-5 col-sm-12 col-xs-12">
                <div
                  className="product-large-image-wrapper"
                  style={{ height: "40vh" }}
                >
                  <Swiper {...gallerySwiperParams}>
                    {product.image &&
                      product.image.map((single, key) => {
                        return (
                          <div key={key}>
                            <div className="single-image-modal">
                              <img
                                src={global.baseUrlImage + single}
                                id={"image-prod-" + product.id}
                                onError={() => {
                                  var elms = document.querySelectorAll(
                                    "[id='" + "image-prod-" + product.id + "']"
                                  );
                                  for (var i = 0; i < elms.length; i++) {
                                    elms[i].src = global.placeholderImage;
                                    elms[i].style.objectFit = "contain";
                                  }
                                }}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                          </div>
                        );
                      })}
                    {product.image.length == 0 && (
                      <div>
                        <div className="single-image-modal">
                          <img
                            id={"image-prod-" + product.id}
                            src={global.placeholderImage}
                            className="img-fluid"
                            onError={() => {
                              var elms = document.querySelectorAll(
                                "[id='" + "image-prod-" + product.id + "']"
                              );
                              for (var i = 0; i < elms.length; i++) {
                                elms[i].src = global.placeholderImage;
                                elms[i].style.objectFit = "contain";
                              }
                            }}
                            alt=""
                          />
                        </div>
                      </div>
                    )}
                  </Swiper>
                </div>
                <div className="product-small-image-wrapper mt-15">
                  <Swiper {...thumbnailSwiperParams}>
                    {product.image &&
                      product.image.map((single, key) => {
                        return (
                          <div key={key}>
                            <div className="single-image-modal">
                              <img
                                style={{ width: "136.5px !important" }}
                                id={"image-prod-" + product.id}
                                src={global.baseUrlImage + single}
                                onError={() => {
                                  var elms = document.querySelectorAll(
                                    "[id='" + "image-prod-" + product.id + "']"
                                  );
                                  for (var i = 0; i < elms.length; i++) {
                                    elms[i].src = global.placeholderImage;
                                    elms[i].style.objectFit = "contain";
                                  }
                                }}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                          </div>
                        );
                      })}
                  </Swiper>
                </div>
              </div>
              <div className="col-md-7 col-sm-12 col-xs-12">
                <div className="product-details-content quickview-content">
                  <h2>{product.name}</h2>
                  <div
                    className="product-details-price"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    {
                      /*discountedprice !== null ? (
                    <Fragment>
                      <span>
                        {currency.currencySymbol + finaldiscountedprice}
                      </span>{" "}
                      {/*<span className="old">
                        {currency.currencySymbol + finalproductprice}
                  </span>
                    </Fragment>
                  ) : */
                      (isBetaRicambi
                        ? clienteVisualizzaPrezzi
                        : isLoggedUser || visualizzaPrezzi) && (
                        <span>
                          {currency.currencySymbol +
                            parseFloat(selectedProductPrice).toFixed(2)}{" "}
                        </span>
                      )
                    }
                  </div>
                  {isLoggedUser && product.rating && product.rating > 0 ? (
                    <div
                      className="pro-details-rating-wrap"
                      style={{ display: "none" }}
                    >
                      <div className="pro-details-rating">
                        <Rating ratingValue={product.rating} />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/*<div className="pro-details-list"> descrizione emilio io la metterei in baso
                  <p>{product.shortDescription}</p>
              </div>*/}

                  {product.variation.lenght > 0 ? (
                    <div
                      className="pro-details-size-color"
                      style={{ display: "inline-block" }}
                    >
                      <div className="pro-details-color-wrap">
                        <span>Colore</span>
                        <div className="pro-details-color-content">
                          {product.variation.map((single, key) => {
                            return (
                              <label
                                className={`pro-details-color-content--single ${single.color}`}
                                key={key}
                              >
                                <input
                                  type="radio"
                                  value={single.color}
                                  name="product-color"
                                  checked={
                                    single.color === selectedProductColor
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={() => {
                                    setSelectedProductColor(single.color);
                                    setSelectedProductSize(single.size[0].name);
                                    setSelectedIDArt(
                                      single.size[0].IDArtSizeColor
                                    );
                                    setProductStock(single.size[0].stock);
                                    setSelectedProductPrice(
                                      single.size[0].pricesco
                                    );
                                    setQuantityCount(0);
                                  }}
                                />
                                <span
                                  style={{
                                    backgroundColor: single.hexColor
                                      ? toColor(single.hexColor)
                                      : "",
                                    backgroundImage: single.hexColor
                                      ? null
                                      : "url('https://dgaplanetshirt.com/assets/img/COLORI/" +
                                        single.color.split("-")[0] +
                                        ".png')",
                                    backgroundSize: "contain",
                                    position: "absolute",
                                    top: "-7px",
                                    left: "-4px",
                                    width: "20px",
                                    height: "20px",
                                    border:
                                      single.color === selectedProductColor
                                        ? "2px solid #333"
                                        : "2px solid #d9d9d9",
                                    borderRadius: "50%",
                                    content: "",
                                    transition: "0.3s",
                                  }}
                                ></span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                      <div className="pro-details-size">
                        <span>Taglia</span>
                        <div className="pro-details-size-content">
                          {product.variation &&
                            product.variation.map((single) => {
                              return single.color === selectedProductColor &&
                                single.size
                                ? single.size.map((singleSize, key) => {
                                    return (
                                      <label
                                        className={`pro-details-size-content--single`}
                                        key={key}
                                      >
                                        <input
                                          type="radio"
                                          value={singleSize.name}
                                          checked={
                                            singleSize.name ===
                                            selectedProductSize
                                              ? "checked"
                                              : ""
                                          }
                                          onChange={() => {
                                            setSelectedProductSize(
                                              singleSize.name
                                            );
                                            setSelectedIDArt(
                                              singleSize.IDArtSizeColor
                                            );
                                            setProductStock(singleSize.stock);
                                            setSelectedProductPrice(
                                              singleSize.pricesco
                                            );
                                            setQuantityCount(0);
                                          }}
                                        />
                                        <span className="size-name">
                                          {singleSize.name}
                                        </span>
                                      </label>
                                    );
                                  })
                                : "";
                            })}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {product.category ? (
                    <div className="pro-details-meta">
                      <span>Categorie :</span>
                      <ul>{product.category}</ul>
                    </div>
                  ) : (
                    ""
                  )}
                  {product.tag.lenght > 0 ? (
                    <div className="pro-details-meta">
                      <span style={{ width: "15%" }}>Tags :</span>
                      <ul>
                        {product.tag.map((single, key) => {
                          return (
                            <li key={key}>
                              <Link
                                to={
                                  process.env.PUBLIC_URL +
                                  "/shop-grid-full-width"
                                }
                              >
                                {single}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  {product.affiliateLink ? (
                    <div className="pro-details-quality">
                      <div className="pro-details-cart btn-hover">
                        <a
                          href={product.affiliateLink}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          Buy Now
                        </a>
                      </div>
                    </div>
                  ) : (
                    isLoggedUser && (
                      <div className="pro-details-quality">
                        {product.variation.length == 0 && (
                          <span>{qtaInCart} pz già nel carrello</span>
                        )}
                        <div className="cart-plus-minus">
                          <button
                            onClick={() =>
                              setQuantityCount(
                                quantityCount > 1 ? quantityCount - 1 : 1
                              )
                            }
                            className="dec qtybutton"
                          >
                            -
                          </button>
                          <input
                            className="cart-plus-minus-box"
                            type="text"
                            value={quantityCount}
                            onChange={(e) => setQuantityCount(e.target.value)}
                          />
                          <button
                            onClick={() =>
                              setQuantityCount(
                                quantityCount < productStock - productCartQty
                                  ? quantityCount + 1
                                  : quantityCount
                              )
                            }
                            className="inc qtybutton"
                          >
                            +
                          </button>
                        </div>

                        <div className="pro-details-cart btn-hover">
                          {productStock && productStock > 0 ? (
                            <button
                              onClick={() => {
                                if (quantityCount == 0) return;
                                const colorProduct = product?.variation?.find(
                                  (c) => c.color === selectedProductColor
                                );
                                const tagliaInfo = colorProduct?.size.find(
                                  (s) => s.name === selectedProductSize
                                );
                                var nonPrenotabile = false;
                                var nonEsiste = false;
                                if (global.aziendaID == 2) {
                                  nonPrenotabile = false;
                                  nonEsiste = false;
                                } else {
                                  nonPrenotabile =
                                    tagliaInfo.stock <= 0 &&
                                    tagliaInfo.stock - tagliaInfo.qtaOrdFor <=
                                      0 &&
                                    tagliaInfo.qtaOrdFor -
                                      tagliaInfo.qtaImpCli <=
                                      0 &&
                                    tagliaInfo.tag?.includes("PROMEMORIA");
                                  nonEsiste = tagliaInfo.flgNoWeb == 1;
                                }
                                if (nonPrenotabile || nonEsiste) {
                                  addToast(
                                    "L'articolo non può essere aggiunto al carrello",
                                    {
                                      appearance: "error",
                                      autoDismiss: true,
                                      placement: "bottom-left",
                                    }
                                  );
                                  return;
                                }
                                //console.log(selectedIDArt);
                                addToCart(
                                  product,
                                  addToast,
                                  quantityCount,
                                  selectedProductColor,
                                  selectedProductSize,
                                  selectedIDArt,
                                  tagliaInfo?.ord1,
                                  tagliaInfo?.ord2,
                                  setQuantityCount
                                );
                                setQuantityCount(0);
                              }}
                              disabled={productCartQty >= productStock}
                            >
                              {" "}
                              {strings.add_to_cart}
                            </button>
                          ) : (
                            <button disabled>Non disponibile</button>
                          )}
                        </div>

                        {isLoggedUser ? (
                          wishlistItem !== undefined ? (
                            <div className="pro-details-wishlist">
                              <button
                                style={{
                                  borderColor: "transparent",
                                  backgroundColor: "transparent",
                                }}
                                className={"active"}
                                disabled={false}
                                title={"Rimuovi dai preferiti"}
                                onClick={() =>
                                  removeFromWishlist(product, addToast)
                                }
                              >
                                <i
                                  style={{ color: "lightblue" }}
                                  class="fa fa-heart fa-2x"
                                  title="Rimuovi dai preferiti"
                                ></i>
                              </button>
                            </div>
                          ) : (
                            <div className="pro-details-wishlist">
                              <button
                                style={{
                                  borderColor: "transparent",
                                  backgroundColor: "transparent",
                                }}
                                className={"active"}
                                disabled={false}
                                title={"Aggiungi ai preferiti"}
                                onClick={() => addToWishlist(product, addToast)}
                              >
                                <i
                                  class="fa fa-heart-o fa-2x"
                                  title="Aggiungi ai preferiti"
                                ></i>
                              </button>
                            </div>
                          )
                        ) : null}

                        <div
                          className="pro-details-compare"
                          style={{ display: "none" }}
                        >
                          <button
                            className={
                              compareItem !== undefined ? "active" : ""
                            }
                            disabled={compareItem !== undefined}
                            title={
                              compareItem !== undefined
                                ? "Added to compare"
                                : "Add to compare"
                            }
                            onClick={() => addToCompare(product, addToast)}
                          >
                            <i className="pe-7s-shuffle" />
                          </button>
                        </div>
                      </div>
                    )
                  )}

                  {getTableInfo()}
                </div>
              </div>
            </div>
          </div>
        )}
        {global.aziendaID == 1 && <ProductMobile {...props} />}
      </Modal>
    </Fragment>
  );
}
const mapDispatchToProps = (dispatch) => {
  return {};
};
const mapStateToProps = (state) => {
  return {
    cartItems: state.cartData,
    userData: state.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductModal);
